import { PickRateDto } from 'common/api/dto/rates.dto';
import currency from 'currency.js';
import { useMemo, useState } from 'react';
import { Column } from 'react-table';
import {
  RateFormProps,
  TableRateInput,
} from '../components/Sub-views/RatesView/Tabs/TableRateInput';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';

export type PickRateTableRows = {
  varietyCode: string;
  rate: RateFormProps;
};

export const usePickRatesTableData: {
  (
    rows: PickRateDto[],
    isSubmitting: boolean,
  ): {
    columns: Column<PickRateTableRows>[];
    data: PickRateTableRows[];
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
  };
} = (rows, isSubmitting) => {
  const [isEditing, setIsEditing] = useState(false);

  const columns: Column<PickRateTableRows>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Variety</CenteredHeader>,
        accessor: 'varietyCode',
        width: '50%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        Header: () => <CenteredHeader>Pick Rate</CenteredHeader>,
        accessor: 'rate',
        width: '50%',
        Cell: ({ value }) => (
          <TableRateInput
            showInput={isEditing}
            value={value}
            isSubmitting={isSubmitting}
          />
        ),
      },
    ],
    [isEditing, isSubmitting],
  );

  const data: PickRateTableRows[] = useMemo(
    () =>
      rows.map(({ id, varietyCode, rate }) => ({
        varietyCode,
        rate: {
          formValueKey: id.toString(),
          displayValue: rate ? currency(rate).format() : '$0',
        },
      })),
    [rows],
  );

  return {
    columns,
    data,
    isEditing,
    setIsEditing,
  };
};
